// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"52859638","147":"48198676","362":"0e8488be","504":"8ba8001e","574":"6c85020d","807":"d0701095","815":"5be7d004","818":"f0e4c81d","900":"815301c4","959":"5386e7c5","996":"9c6ae4f4"}[chunkId] + ".chunk.js";
};